
$(document).ready(() =>
{

    let observer = null;
    const now = new Date();
    let currentYear = now.getFullYear();
    let currentMonth = now.getMonth();
    let currentDate = now.getDate();

    const checkPreventPastDatesCalendars = () => {
        const $datepickerDiv = $("#ui-datepicker-div");
        if(!$datepickerDiv.length){
            return;
        }
        const $calendars = $datepickerDiv.find(".ui-datepicker-calendar");
        $calendars.each((index, element) => {
            const $calendar= $(element)
            const $days = $calendar.find("[data-handler='selectDay']");
            $days.each((index, element) => {
                const $day = $(element);
                let year = $day.data("year");
                let month = $day.data("month");
                let date = $day.find("a").data("date");
                let disabled = false;
                if(!isNaN(year) && !isNaN(month) && !isNaN(date)){
                    year = parseInt(year);
                    month = parseInt(month);
                    date = parseInt(date);
                    if(year < currentYear){
                        disabled = true;
                    } else if(year === currentYear){
                        if(month < currentMonth){
                            disabled = true;
                        } else if(month === currentMonth){
                            if(date < currentDate){
                                disabled = true;
                            }
                        }
                    }
                }
                if(disabled){
                    $day.addClass("disabled");
                }
            })
        })

        if(observer){
            observer.disconnect();
        }
        observer = new MutationObserver((mutations) => {
            if(mutations.length)
            {
                checkPreventPastDatesCalendars();
            }
        });
        observer.observe($datepickerDiv[0], {
            characterDataOldValue: true,
            subtree: true,
            childList: true,
            characterData: true
        });
    }

    $(".prevent-past-dates .gform-datepicker").click(() => checkPreventPastDatesCalendars())

});